import { SectionKey } from 'types';

type VerifyAnswerStateForSkippedVersionsParams = {
  answerState: PvWizardResultsQueryVariables;
  section: {
    sectionName: SectionKey;
    missingQuestions: string[];
  };
};

// special cases for solarYield and sunKilometers where questions get skipped depending on answers
export const verifyFullyAnsweredQuestionState = ({
  answerState,
  section
}: VerifyAnswerStateForSkippedVersionsParams) => {
  const skipRoofAlignment = answerState.roofPitch === 'FLACH_0_GRAD';
  const skipVehicleQuestions = answerState.hasVehicle === 'no';

  switch (section.sectionName) {
    case 'solarYield':
      const answeredRoofWithoutSkip = section.missingQuestions.length <= 0;
      const answeredRoofWithSkip =
        section.missingQuestions.length <= 1 &&
        section.missingQuestions.includes('roofAlignment') &&
        skipRoofAlignment;
      return answeredRoofWithoutSkip || answeredRoofWithSkip;
    case 'sunKilometers':
      const answeredVehicleWithoutSkip = section.missingQuestions.length <= 0;
      const answeredVehicleWithSkip =
        section.missingQuestions.length <= 3 &&
        section.missingQuestions.includes('vehicleType') &&
        section.missingQuestions.includes('avgMileage') &&
        section.missingQuestions.includes('daysToCharge') &&
        skipVehicleQuestions;
      return answeredVehicleWithoutSkip || answeredVehicleWithSkip;
    default:
      return !Boolean(section.missingQuestions.length);
  }
};
